import styled from "styled-components";

export const YoutubeVideoWrapper = styled.div`
    width: 100%;
    max-width: 940px;
    margin: 0 auto;
`;